import React from 'react'; 
import { FiEdit2, FiTrash2 } from "react-icons/fi";

export const FeaturingItem = ({item}) =>{


    const remove = (id) => {
        //setList(list.filter(item=>item._id!=id));
        //setFieldValue(`${type}`, list.filter(item=>item._id!=id));
    }    

    return (
        <li >
        <div>
            <div>
                 <h4 className="title">{item?.position} </h4>
                 <h3 className="company">{item?.company}</h3>
                 <div className="date">
                     { item?.start && item?.start }
                     {` - `}  { item?.working ? `Continues` :  (item?.end  && item?.end ) }
                     { item?.city  && ` - ` + item.city}
                 </div>
                 <p className="description">{item?.description}</p>
             </div>
             <div className="trash" onClick={()=>remove(item?.code)}>
                 <FiTrash2 />
             </div>
             <div className="edit" onClick={()=>{
                     
             }}><FiEdit2 /> Edit </div>
        </div>
     </li>
    )
}

